export default __webpack_public_path__ + "static/media/73.35d521be.png";